import { useRef } from "react";

let logoInstanceCount = 0;

const Logo = ({ className }) => {
  // The clip-path id must be unique per instance: this logo renders more than
  // once on authenticated pages (sidebar + mobile top bar). A hardcoded id
  // produced duplicate DOM ids, and the second copy's icon clip silently
  // failed (it resolved to the hidden first copy), breaking the mark.
  const clipIdRef = useRef(null);
  if (clipIdRef.current === null) {
    clipIdRef.current = `logo-clip-${++logoInstanceCount}`;
  }
  const clipId = clipIdRef.current;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="160"
      height="40"
      fill="none"
      viewBox="0 0 220 55"
      className={className}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M74.9613 -42.8762C75.9908 -43.9004 76.5728 -44.4344 77.233 -44.649C77.8838 -44.8604 78.5848 -44.8604 79.2356 -44.649C79.9755 -44.4086 80.6171 -43.7669 81.9003 -42.4837L97.481 -26.903C98.7643 -25.6198 99.4059 -24.9781 99.6463 -24.2383C99.8578 -23.5875 99.8578 -22.8864 99.6463 -22.2356C99.4318 -21.5754 98.8978 -20.9934 97.8735 -19.964L74.9613 -42.8762Z"
          fill="currentColor"
        />
        <path
          d="M73.3244 -41.2399L71.6878 -39.6032L94.6006 -16.6904L96.2372 -18.3271L73.3244 -41.2399Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.0511 -37.9666L92.9639 -15.0538L81.9004 -3.99024C81.4192 -3.50903 81.0281 -3.11798 80.6884 -2.80455C80.4889 -2.62054 80.3071 -2.46319 80.1349 -2.32996C79.8183 -2.08495 79.535 -1.92189 79.2352 -1.82455C78.5849 -1.61338 77.8837 -1.6131 77.2325 -1.82455C76.493 -2.06509 75.8514 -2.70671 74.5682 -3.98994L71.9328 -6.62528C70.0473 -8.51081 66.9975 -8.52322 65.0966 -6.66252L44.0633 14.3708C42.2124 16.2724 42.2281 19.3148 44.1103 21.197L46.7454 23.832C48.0286 25.1153 48.6702 25.7569 48.9108 26.4964C49.0411 26.8986 49.0912 27.319 49.0607 27.7349C49.0417 27.9933 48.9916 28.2498 48.9108 28.499C48.7762 28.9127 48.5167 29.2953 48.0896 29.7767C47.7526 30.1568 47.3112 30.5982 46.7451 31.1643L40.6734 37.2359L37.0519 33.6144C39.8684 29.2249 39.3572 23.3176 35.518 19.4785C31.6789 15.6394 25.7717 15.1281 21.3821 17.9447L17.7606 14.3231L23.8323 8.25147C24.5958 7.48789 25.1323 6.95143 25.5977 6.59119C25.9143 6.34617 26.1977 6.1831 26.497 6.08577C27.1478 5.8746 27.849 5.87432 28.5001 6.08577C29.2397 6.32631 29.8813 6.96794 31.1645 8.25119L33.7998 10.8865C35.6979 12.7845 38.7757 12.7845 40.6737 10.8865L61.6459 -10.0856C63.5203 -11.9855 63.5125 -15.0456 61.6223 -16.9358L58.9873 -19.5708C57.7041 -20.854 57.0624 -21.4957 56.8219 -22.2352C56.6916 -22.6374 56.6415 -23.0578 56.672 -23.4737C56.691 -23.7321 56.7411 -23.9886 56.8219 -24.2378C56.8943 -24.4606 57.003 -24.6743 57.1546 -24.8993C57.4697 -25.3672 57.97 -25.8836 58.7147 -26.6299L70.0511 -37.9666ZM70.0511 -15.0538C72.3109 -12.7941 75.9746 -12.7941 78.2343 -15.0538C80.494 -17.3135 80.494 -20.9772 78.2343 -23.2369C75.9746 -25.4967 72.3109 -25.4967 70.0511 -23.2369C67.7914 -20.9772 67.7914 -17.3135 70.0511 -15.0538Z"
          fill="currentColor"
        />
        <path
          d="M17.9452 21.3816L14.3237 17.7601L8.25201 23.8317C7.4711 24.6126 6.92793 25.1558 6.56795 25.6282C6.51286 25.7007 6.46195 25.7717 6.41524 25.8414C6.3635 25.9183 6.31707 25.9938 6.27539 26.0685C6.22281 26.1624 6.1775 26.2559 6.14002 26.3493C6.12044 26.398 6.10254 26.4472 6.08631 26.497C5.87514 27.1473 5.87487 27.8485 6.08632 28.4996C6.23092 28.9452 6.52125 29.3552 7.01015 29.8911C7.33265 30.2449 7.74157 30.6538 8.25174 31.164L23.8326 46.7448C24.6275 47.5397 25.1759 48.0882 25.6542 48.4479C25.9482 48.6691 26.2153 48.8188 26.497 48.9102C27.1481 49.1217 27.8493 49.1214 28.4996 48.9102C28.6853 48.8498 28.864 48.7645 29.0486 48.6504C29.3935 48.437 29.7571 48.1226 30.2155 47.6826C30.4919 47.4175 30.8029 47.1065 31.1648 46.7445L37.2365 40.6729L33.615 37.0513C29.2254 39.8679 23.3182 39.3566 19.4791 35.5175C15.6399 31.6784 15.1287 25.7711 17.9452 21.3816Z"
          fill="currentColor"
        />
      </g>
      <path
        d="M82.1778 44.136H77.8021V25.2941H73.3333V21.6636H77.8021V14.6324H82.1778V21.6636H86.6466V25.2941H82.1778V44.136Z"
        fill="currentColor"
      />
      <path
        d="M102.444 21.4798V25.432H100.489C96.3457 25.432 93.7855 27.9136 93.7855 32.2335V44.136H89.4098V21.7096H93.5062L93.7855 25.1103C94.7165 22.7665 96.9974 21.204 100.116 21.204C100.908 21.204 101.559 21.296 102.444 21.4798Z"
        fill="currentColor"
      />
      <path
        d="M121.118 21.6636H125.447V44.136H121.537L121.071 40.7353C119.768 43.079 116.742 44.6875 113.391 44.6875C108.084 44.6875 105.105 41.1489 105.105 35.6342V21.6636H109.481V34.2096C109.481 39.0349 111.575 40.8732 114.927 40.8732C118.93 40.8732 121.118 38.3456 121.118 33.5202V21.6636Z"
        fill="currentColor"
      />
      <path
        d="M128.688 32.9228C128.688 25.8915 133.203 21.0202 139.86 21.0202C145.586 21.0202 149.589 24.2371 150.38 29.2463H146.005C145.26 26.3971 142.932 24.8805 140 24.8805C135.857 24.8805 133.017 28.0055 133.017 32.8768C133.017 37.7022 135.67 40.8272 139.813 40.8272C142.932 40.8272 145.26 39.2188 146.051 36.5533H150.427C149.542 41.4246 145.306 44.6875 139.813 44.6875C133.11 44.6875 128.688 40 128.688 32.9228Z"
        fill="currentColor"
      />
      <path
        d="M158.349 44.136H153.973V10.3125H158.349V32.2335L168.45 21.6636H173.943L165.238 30.625L173.896 44.136H168.869L162.212 33.75L158.349 37.7482V44.136Z"
        fill="currentColor"
      />
      <path
        d="M191.763 44.136V25.2941H181.662V44.136H177.286V25.2941H173.934V21.6636H177.286V18.079C177.286 12.5643 180.312 10.3125 184.268 10.3125C185.106 10.3125 186.13 10.3585 186.968 10.4963V14.2188H185.013C182.36 14.2188 181.662 15.6434 181.662 18.079V21.6636H196.139V44.136H191.763ZM193.951 16.1489C192.368 16.1489 191.158 14.954 191.158 13.3915C191.158 11.829 192.368 10.6342 193.951 10.6342C195.487 10.6342 196.697 11.829 196.697 13.3915C196.697 14.954 195.487 16.1489 193.951 16.1489Z"
        fill="currentColor"
      />
      <path
        d="M203.521 44.136H198.494L206.454 33.0147L198.54 21.6636H203.614L209.387 30.0276L215.019 21.6636H220L212.086 33.0147L219.86 44.136H214.786L209.107 35.9099L203.521 44.136Z"
        fill="currentColor"
      />
      <defs>
        <clipPath id={clipId}>
          <rect
            width="32.4091"
            height="42.1183"
            fill="currentColor"
            transform="translate(30.9277 1.15601) rotate(45)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
